import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Message, SelectItem } from "primeng/components/common/api";
import { AppConstants } from "../core/app.constants";
import { AuthAccessProvider } from "../core/core.auth";
import { BaseComponent, Stima, Offer, UserContext, ProjectResponse, Project, UserInfo } from "../core/core.component";
import { BusyProvider } from "../service/busy.service";
import { MessageProvider } from "../service/message.service";
import { StimeService } from "app/service/stime.service";
import { TaskService } from '../service/task.service';
import { OfferService } from "app/service/offers.service";
import { ReportService } from 'app/service/report.service';
import * as FileSaver from 'file-saver';
import { DatePipe } from "@angular/common";

declare var $: any;

@Component({
	selector: "app-stime",
	templateUrl: "./stime.component.html",
	styleUrls: ["./stime.component.css"],
})
export class StimeComponent extends BaseComponent implements OnInit {
	stime: Stima[] = [];
	userContext: UserContext;
	userInfo: UserInfo = new UserInfo();

	locale: any = AppConstants.ITA_CALENDAR_CONF;
	it: any = AppConstants.ITA_CALENDAR_CONF;
	users: SelectItem[] = [];
	filterDsRichiesta: string = null
	filterRefOrder: string = null
	filterCodRichiesta: string = null
	filterDtinizio: Date = new Date(new Date().setDate(1));
	filterDtfine: Date = new Date(this.filterDtinizio.getFullYear(), this.filterDtinizio.getMonth() + 1, 0);
	filterPriorita: string = null
	filterAcept: string = null
	filterTicket: string = null;
	loading: boolean = false;
	validationMessage: string = null;
	showDeleteAlert: boolean = false;
	showFilter: boolean = false;

	prioOptions = [
		{ label: 'Ordinaria', value: 'O' },
		{ label: 'Urgente', value: 'U' },
	];
	prioFilterOptions = [
		{ label: '...', value: null },
		{ label: 'Urgente', value: 'U' },
		{ label: 'Ordinaria', value: 'O' },
	];
	aceptOptions = [
		{ label: '...', value: null },
		{ label: 'Si', value: 'S' },
		{ label: 'No', value: 'N' },
	];

	filterAceptOptions = [
		{ label: '...', value: null },
		{ label: 'Si', value: 'S' },
		{ label: 'No', value: 'N' },
		{ label: 'Nessuna Risposta', value: 'U' },
	];

	sortField = 'reforder';
	sortAsc = true;
	idstima: number = null;
	reforder: string = null;
	dsRichiesta: string = null;
	codRichiesta: string = null;
	priority: string = "O"
	giornate: number = null;
	dtRichiesta: Date = null;
	dtRisposta: Date = null;
	acept: string = null;
	stimaSelected: Stima = new Stima;

	onlyActiveFilter: boolean = true;
	onlyActive: boolean = true;
	isPlafond: boolean = false;
	isPlafondFilter: boolean = false;
	filterDaEffettuare: boolean = false;

	offersAttive: Offer[] = [];
	offers: Offer[] = [];
	commesseOptions: SelectItem[] = [];
	commesseFiltered: SelectItem[] = [];
	projects: SelectItem[] = []; // ad uso del filtro per task
	forceReloadFilterTask = false;
	tasksFiltered: SelectItem[] = [];
	tasks: SelectItem[] = [];
	ticket: string = null;
	href: string = null;

	idTicketSelected: number = null;

	msgs: Message[] = [];

	checkCreaTicket = true;

	constructor(
		protected authAccess: AuthAccessProvider,
		protected router: Router,
		protected messageProvider: MessageProvider,
		private busyProvider: BusyProvider,
		private stimeService: StimeService,
		private offerService: OfferService,
		private taskService: TaskService,
		private reportService: ReportService,
		private datePipe: DatePipe,
	) {
		super(authAccess, router, messageProvider);
		this.messageProvider.clearAll();
	}

	ngOnInit() {
		this.userContext = this.authAccess.getUserContext();
		if (this.userContext == null) {
			this.authAccess.invalidate();
		} else {
			this.loadStime();
			this.loadOffers(false);	// Recupero tutte le offerte
			this.loadOffers(true);	// FIXME: pattern pessimo, doppia chiamata alle offerte 
			
			this.taskService.getUserProjects(this.userContext.srmToken).subscribe(
				response => {
					let projectResponse: ProjectResponse = response;
					for (let i = 0; i < projectResponse.userProjects.length; ++i) {
						let project: Project = projectResponse.userProjects[i];
						this.projects.push({ label: project.name, value: project.id });
					}
					this.caricaIssues();
				},
				error => {
					this.handleError(error);
				}
			);
		}
	}

	loadStime() {
		this.stime = [];
		this.loading = true;

		this.stimeService.getStime(this.userContext.srmToken, this.filterDsRichiesta, this.filterCodRichiesta, this.filterRefOrder, this.filterPriorita, this.filterDtinizio, this.filterDtfine, this.filterAcept, this.filterTicket, this.filterDaEffettuare).subscribe(
			(result) => {
				if (result.message) {

					const stime = JSON.parse(result.message);
					this.stime = stime;
					this.sort(this.sortField, this.sortAsc);
					this.loading = false;
					this.selectStima(this.stimaSelected);
				}
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	applyFilter() {
		this.loadStime();
		this.showFilter = false;
	}

	removeFilter() {
		this.resetFilter();
		this.loadStime();
		this.showFilter = false;
	}

	resetFilter() {
		this.filterRefOrder = null;
		this.filterDsRichiesta = null;
		this.filterCodRichiesta = null;
		this.filterDtinizio = null;
		this.filterDtfine = null;
		this.filterPriorita = null;
		this.filterAcept = null;
		this.filterTicket = null;
	}

	sort(field: string, asc?: boolean) {
		if (field === this.sortField && (typeof asc === 'undefined' || asc == !this.sortAsc)) {
			this.stime = this.stime.reverse();
			this.sortAsc = !this.sortAsc;
		} else {
			this.sortField = field;
			this.stime = this.stime.sort((a1, a2) => {
				var res = 0;
				if (this.sortField === 'reforder') {
					res = this.compareStrings(a1.reforder, a2.reforder);
				} else if (this.sortField === 'dsRichiesta') {
					res = this.compareStrings(a1.dsrichiesta, a2.dsrichiesta);
				}
				else if (this.sortField === 'codRichiesta') {
					res = this.compareStrings(a1.codrichiesta, a2.codrichiesta);
				} else if (this.sortField === 'giornate') {
					res = a1.giornate > a2.giornate ? 1 : -1;
				} else if (this.sortField === 'priority') {
					res = this.compareStrings(a1.priorita, a2.priorita);
				} else if (this.sortField === 'tsRichiesta') {
					res = this.compareDates(a1.tsrichiesta, a2.tsrichiesta);
				} else if (this.sortField === 'tsRisposta') {
					res = this.compareDates(a1.tsrisposta, a2.tsrisposta);
				} else if (this.sortField === 'acept') {
					res = this.compareStrings(a1.accettata, a2.accettata);
				} return this.sortAsc ? res : -res;
			});
		}
	}

	private compareStrings(s1: string, s2: string) {
		return (s1 ? s1.toLowerCase() : '') > (s2 ? s2.toLowerCase() : '') ? 1 : -1;
	}

	private compareDates(d1: Date, d2: Date) {
		if (!d1 && !d2) {
			return 0;
		} else if (!d1) {
			return -1;
		} else if (!d2) {
			return 1;
		} else {
			return +new Date(d1) - +new Date(d2);
		}
	}

	toggleFilter() {
		this.showFilter = !this.showFilter;
	}

	storeStime() {
		this.checkDatiInseriti();
		if (this.validationMessage != null) {
			return;
		}
		// modifica
		if (this.stimaSelected.reforder != null) {
			this.busyProvider.showBusyIndicator();
			let stima: Stima = this.buildStima();
			stima.reforder = this.stimaSelected.reforder;
			this.stimeService.updateOffer(this.userContext.srmToken, stima).subscribe(
				() => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Modifica eseguita correttamente" });
					this.loadStime();
					this.selectStima(stima);
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
		// inserimento
		else {
			this.busyProvider.showBusyIndicator();
			let stima: Stima = this.buildStima();
			this.stimeService.insertStima(this.userContext.srmToken, stima, this.checkCreaTicket).subscribe(
				(result) => {
					this.busyProvider.hideBusyIndicator();
					this.msgs = [];
					this.msgs.push({ severity: "success", summary: "OK", detail: "Stima inserita correttamente" });
					this.aggiornaStimaDaInsert(stima, result);
					this.selectStima(stima);
					this.loadStime();
				},
				(error) => {
					this.busyProvider.hideBusyIndicator();
					this.handleError(error);
				}
			);
		}
	}

	private aggiornaStimaDaInsert(stima: Stima, result: any) {
		try {
			const inserted = JSON.parse(result.message);
			if (inserted.idstima != null) {
				stima.idstima = inserted.idstima;
			}
			if (inserted.ticket) {
				stima.ticket = inserted.ticket;
				this.tasks.push({
					label: inserted.ticket,
					value: { id: inserted.issueId, issueNo: inserted.ticket, title: inserted.title, href: inserted.href }
				});
			}
		} catch (e) {
			// response non in formato JSON: nessuna informazione sul ticket disponibile
		}
	}

	checkDatiInseriti() {
		this.messageProvider.clearAll();
		this.validationMessage = null;

		if (this.reforder == null || this.reforder.trim() == "") {
			this.validationMessage = "Inserire il codice dell'ordine";
			return;
		}

		if (this.dsRichiesta == null) {
			this.validationMessage = "Inserire la descrizione della richiesta";
			return;
		}
		if (this.priority == null) {
			this.priority = 'O'
		}

		if (this.dtRichiesta == null) {
			this.validationMessage = "Inserire la data della richiesta";
			return;
		}
	}

	buildStima(): Stima {
		let stima: Stima = new Stima();
		stima.idstima = this.idstima;
		stima.reforder = this.reforder;
		if (this.reforder == null) {
			stima.reforder = this.stimaSelected.reforder;
		}
		stima.dsrichiesta = this.dsRichiesta;
		stima.codrichiesta = this.codRichiesta;
		stima.priorita = this.priority;
		stima.tsrichiesta = this.dtRichiesta;
		stima.tsrisposta = this.dtRisposta;
		if (this.giornate != null && Number(this.giornate) != 0) {
			stima.giornate = Number(this.giornate);
		} else {
			stima.giornate = null;
		}
		stima.accettata = this.acept;
		stima.ticket = this.ticket;
		return stima;
	}

	selectStima(stima: Stima) {
		this.validationMessage = null;
		this.idstima = stima.idstima;
		this.reforder = stima.reforder;
		this.stimaSelected = stima;
		this.dsRichiesta = this.stimaSelected.dsrichiesta;
		this.codRichiesta = stima.codrichiesta;
		this.priority = stima.priorita;

		if (stima.tsrichiesta != null) {
			this.dtRichiesta = new Date(stima.tsrichiesta);
		}
		else {
			this.dtRichiesta = null;
		}
		if (stima.tsrisposta != null) {
			this.dtRisposta = new Date(stima.tsrisposta);
		}
		else {
			this.dtRisposta = null;
		}
		this.acept = stima.accettata;
		if (stima.giornate != null) {
			this.giornate = stima.giornate;
		}
		else {
			this.giornate = null;
		}
		this.ticket = stima.ticket;
		this.idTicketSelected = null;
		this.href = null;
		if (this.ticket != null && this.ticket != "" && this.tasks.length != 0) {
			let task = this.tasks.find(t => t.label === this.ticket);
			if (task) {
				this.idTicketSelected = task.value.id;
				if (task.value.href) {
					this.href = task.value.href;	// link già noto: nessuna chiamata al backend
				} else {
					this.recuperaTicket(this.idTicketSelected, false);
				}
			}
		}
	}

	onTaskSelected(event) {
		this.dsRichiesta = event.value.title;
		this.ticket = event.value.issueNo;
		this.recuperaTicket(event.value.id, true);
	}

	addNewStima() {
		this.validationMessage = null;
		this.reforder = "";
		this.dsRichiesta = null;
		this.codRichiesta = null;
		this.priority = null;
		this.giornate = null;
		this.dtRichiesta = null;
		this.dtRisposta = null;
		this.acept = "";
		this.ticket = null;
		this.tasksFiltered = [];
		this.filterRefOrder = null;
		this.commesseFiltered = [];
		this.href = null;
		this.messageProvider.clearAll();
		this.stimaSelected = new Stima();
	}

	openDeleteStima(current: Stima) {
		this.selectStima(current);
		this.showDeleteAlert = true;
	}

	closeDeleteAlert() {
		this.showDeleteAlert = false;
	}

	deleteStima() {
		this.messageProvider.clearAll();
		this.validationMessage = null;

		this.busyProvider.showBusyIndicator();
		this.stimeService.deleteStima(this.userContext.srmToken, this.idstima).subscribe(
			result => {
				this.busyProvider.hideBusyIndicator();
				this.msgs = [];
				this.msgs.push({ severity: 'success', summary: 'OK', detail: 'Cancellazione eseguita correttamente' });
				this.addNewStima();
				this.loadStime();
			},
			error => {
				this.busyProvider.hideBusyIndicator();
				this.handleError(error);
			});
	}

	aggiorna() {
		this.loadStime();
	}

	decodificaPriorita(prio: string): string | null {
		if (prio != null) {
			if (prio.localeCompare("U") === 0) {
				return "Urgente";
			} else if (prio.localeCompare("O") === 0) {
				return "Ordinaria";
			}
		}
		return null;
	}

	decodificaAccettata(acept: string): string | null {
		if (acept != null) {
			if (acept.localeCompare("S") === 0) {
				return "Sì";
			} else if (acept.localeCompare("N") === 0) {
				return "No";
			}
		}
		return null;
	}

	filterTaskFilter(event) {
		this.tasksFiltered = [];
		if (this.tasks.length == 0) {
			this.tasksFiltered.push({ label: 'Caricamento in corso...', value: '' });
		} else {
			const query = event.query.toLowerCase();

			this.tasks
				.filter(issue =>
					issue.value.issueNo.toLowerCase().includes(query) ||
					issue.value.title.toLowerCase().includes(query)
				)
				.forEach(issue => {
					this.tasksFiltered.push({
						label: issue.value.issueNo + ' - ' + issue.value.title,
						value: issue.value.issueNo
					});
				});
		}
	}

	filterTask(event) {
		this.tasksFiltered = [];
		if (this.tasks.length == 0) {
			this.tasksFiltered.push({ label: 'Caricamento in corso...', value: '' });
		} else {
			const query = event.query.toLowerCase();

			this.tasks
				.filter(issue =>
					issue.value.issueNo.toLowerCase().includes(query) ||
					issue.value.title.toLowerCase().includes(query)
				)
				.forEach(issue => {
					this.tasksFiltered.push({
						label: issue.value.issueNo + ' - ' + issue.value.title,
						value: issue.value
					});
				});
		}
	}

	caricaSuggerimentiCommesse(isFilter: boolean) {
		let offerte;
		if ((isFilter && this.onlyActiveFilter) || (!isFilter && this.onlyActive)) {
			offerte = this.offersAttive;
			if ((!isFilter && this.isPlafond) || (this.isPlafondFilter && isFilter)) {
				offerte = this.offersAttive.filter(o => o.tipologia == "P");
			}
		}

		else {
			offerte = this.offers;
			if (this.isPlafond || this.isPlafondFilter) {
				offerte = this.offers.filter(o => o.tipologia == "P")
			}
		}
		this.commesseOptions = offerte				//ordine alfabetico dei clienti nel dropdown
			.map(offer => ({
				label: offer.dsofferta,
				value: offer.reforder
			}))
			.sort((a, b) => a.label.localeCompare(b.label, 'it', { sensitivity: 'base' }));
	}

	filterOffer(event, isFilter) {
		this.caricaSuggerimentiCommesse(isFilter);
		this.commesseFiltered = AppConstants.filterSuggestions(this.commesseOptions, event.query, item => [item.label, item.value]);
	}

	onSelectOffer(offer: any, isFilter: boolean) {
		if (!isFilter) {
			this.reforder = offer.value;
		}
		else {
			this.filterRefOrder = offer.value;
			//this.filterDsRichiesta = offer.value + " - " + offer.label;//decommentare se si vuole l'autocompletamneto della descrizione
		}
	}

	onSelectTicketFilter(task: any) {
		this.filterTicket = task.value ? task.value : null;
	}

	private emptyToNull(value: string): string {
		return value != null && value.trim() !== '' ? value : null;
	}

	loadOffers(onlyActive?: boolean) {
		this.offers = [];
		this.offerService.getOffers(this.userContext.srmToken, onlyActive, null, null).subscribe(
			(result) => {
				if (result.message) {
					try {
						const offers = JSON.parse(result.message);
						if (!offers || offers.length === 0) {
							console.warn("Nessuna commessa trovata!");
							return;
						}
						if (onlyActive) {
							this.offersAttive = offers;
						} else {
							this.offers = offers;
						}
					} catch (e) {
						console.error("Errore nel parsing JSON:", e);
					}
				}
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	recuperaLink(issueNo: string): string {
		let result = null;
		if (this.tasks.length != 0 && issueNo != null) {
			let task = this.tasks.find(t => t.label === issueNo);
			if (task) {
				result = task.value.href;
			}
		}
		return result;
	}

	caricaIssues() {
		this.tasks = [];
		const projectIds = (this.projects.find(p => p.label.includes("SITECH"))).value;
		this.taskService.searchTaskByProject(this.userContext.srmToken, "SIT", projectIds, 10000, this.forceReloadFilterTask).subscribe(
			result => {
				this.forceReloadFilterTask = false;
				result.issues.forEach(issue => {
					this.tasks.push({ label: issue.issueNo, value: issue });
				});
			}
		);
	}

	recuperaTicket(id: number, onTaskSelected: boolean) {
		this.href = null;
		const projectIds = (this.projects.find(p => p.label.includes("SITECH"))).value;
		this.taskService.getIssueById(this.userContext.srmToken, id, projectIds, false).subscribe(
			(result) => {
				if (result) {
					try {
						if (result.issues.length != 0) {
							if (this.idTicketSelected == result.issues[0].id || onTaskSelected) { //controllo che l'utente non abbia selezionato un'altra scadenza prima del recupero di questi dati
								this.href = result.issues[0].href;
								if (onTaskSelected) {	//Aggiorno la stima del tempo solo all'aggiunta di un nuovo task
									let tempoStimato = result.issues[0].estimatedTime;
									if (tempoStimato != null) {
										this.giornate = tempoStimato.months * 30 + tempoStimato.weeks * 7 + tempoStimato.days + Math.round(tempoStimato.hours / 8);
									}
								}
							}
						}
					} catch (e) {
						console.error("Errore", e);
					}
				}
			},
			(error) => {
				this.handleError(error);
				this.loading = false;
			}
		);
	}

	exportReport() {

		this.busyProvider.showBusyIndicator();
		this.messageProvider.clearAll();

		const parameters = new Object();

		parameters['filterCodRichiesta'] = this.emptyToNull(this.filterCodRichiesta);
		parameters['filterDsRichiesta'] = this.emptyToNull(this.filterDsRichiesta);
		parameters['filterRefOrder'] = this.emptyToNull(this.filterRefOrder);
		parameters['filterPriorita'] = this.filterPriorita;
		parameters['filterDtinizio'] = this.datePipe.transform(this.filterDtinizio, "yyyy-MM-dd");
		parameters['filterDtfine'] = this.datePipe.transform(this.filterDtfine, "yyyy-MM-dd");
		parameters['filterAcept'] = this.filterAcept;
		parameters['filterTicket'] = this.emptyToNull(this.filterTicket);
		parameters['filterDaEffettuare'] = this.filterDaEffettuare;

		this.reportService.exportReport(this.userContext.srmToken, 'com.netsitech.srm.excel.generator.StimeReportGenerator', parameters).
			subscribe(
				data => {
					this.busyProvider.hideBusyIndicator();
					let filename = "Report_Stime_" + new Date().getTime() + ".xlsx";
					this.download(data, filename);
				},
				error => {
					this.busyProvider.hideBusyIndicator();
					// nei report ci si aspetta un blob pertanto gli eventuali errori in json
					// non vengono correttamente mappati, pertanto non si utilizza la funzione
					// generica handleError ma si visualizza l'errore così com'è.
					this.messageProvider.notifyError(error);
				});


	}

	private download(data: any, filename: string) {
		let blob = new Blob([data], { type: "application/vnd.ms-excel" });
		FileSaver.saveAs(blob, filename);
	}

	checkDaEffettuare() {
		if (this.filterDaEffettuare) {
			this.filterAcept = null;
		}
		this.aggiorna();
	}

	svuotaCheckDaEffettuare() {
		this.filterDaEffettuare = null;
	}

}



// WEBPACK FOOTER //
// ./src/app/stime/stime.component.ts